import parse from 'html-react-parser';

export const parseCopy = (copy: string) => {
  try {
    const parsedCopy = parse(copy);

    return parsedCopy;
  } catch (error) {
    console.error('Error parsing SectionCopy content', error);
    return null;
  }
};
